import type { AgentStateSyncPayload } from "schemas/generated/agentConnection";

import { createShallowStore } from "replo-utils/react/zustand";

type PublishSyncStatus = NonNullable<AgentStateSyncPayload["publishStatus"]>;

type DebugPublishStatusOverrideState = {
  publishStatusOverride: PublishSyncStatus | null;
  actions: {
    setPublishStatusOverride: (status: PublishSyncStatus) => void;
    clearPublishStatusOverride: () => void;
  };
};

const useDebugPublishStatusOverrideStore =
  createShallowStore<DebugPublishStatusOverrideState>((set) => ({
    publishStatusOverride: null,
    actions: {
      setPublishStatusOverride: (status: PublishSyncStatus) => {
        set({ publishStatusOverride: status });
      },
      clearPublishStatusOverride: () => {
        set({ publishStatusOverride: null });
      },
    },
  }));

export const useDebugPublishStatusOverride = () => {
  return useDebugPublishStatusOverrideStore(
    (state) => state.publishStatusOverride,
  );
};

export const useDebugPublishStatusOverrideActions = () => {
  return useDebugPublishStatusOverrideStore((state) => state.actions);
};
